module.exports = __webpack_public_path__ + "static/media/miner-gold-yeti.cef60b78.png";